export default "__VITE_ASSET__33048a44__"